import React, { useState } from "react";
import i18n from "utils/i18n";
import _ from 'lodash'
import { useSelector } from 'react-redux'
import { dataConstants } from 'services/redux/data/constants'
import Form from 'components/molecules/Form'
import { FormFieldsConstants } from 'utils/constants/form-constants';
import ThemedBlock from 'components/atoms/ThemedBlock'
import NoResultsView from 'components/atoms/NoResultsView'
import EmployeeValues from 'scenes/home/more/_functions/Employee'
import HelperSetting from 'utils/helper-setting'
import { privacyOptions, settingsConstants, settingsOptions } from 'utils/constants/settings-constants'
import HelperString from 'utils/helper-string'

const PrivacyTab = () => {
	
	const _employee = useSelector( state => {
		return state.data[dataConstants.EMPLOYEE];
	} )
	
	const [ unique, setUnique ] = useState( HelperString.random() )
	
	const onChange = ( values ) => {
		EmployeeValues.onChangeEmployee( values )
		setUnique( HelperString.random() )
	}
	
	const data = !_.isEmpty( EmployeeValues.values ) ? EmployeeValues.values : {
		visible_for_employees: _.get( _employee, 'visible_for_employees', HelperSetting.get( settingsConstants.PRIVACY_VISIBLE_FOR_EMPLOYEES_DEFAULT ) ),
		show_phonenumber: _.get( _employee, 'show_phonenumber', HelperSetting.get( settingsConstants.PRIVACY_SHOW_PHONENUMBER ) ),
		show_calendar: _.get( _employee, 'show_calendar', HelperSetting.get( settingsConstants.PRIVACY_SHOW_CALENDAR ) ),
		show_favourite: _.get( _employee, 'show_favourite', HelperSetting.get( settingsConstants.PRIVACY_SHOW_FAVOURITE ) ),
	}
	
	if( data.visible_for_employees === privacyOptions.NO ) {
		data.show_phonenumber = privacyOptions.NO;
		data.show_calendar = privacyOptions.NO;
		data.show_favourite = privacyOptions.NO;
	}
	
	const formFields = [
		{
			name: 'visible_for_employees',
			label: i18n.t('form.fields.visible_for_employees.title'),
			hint: i18n.t('form.fields.visible_for_employees.description'),
			type: FormFieldsConstants.SELECT,
			options: [
				{ value: settingsOptions.YES, label: i18n.t( 'basic.yes') },
				{ value: settingsOptions.NO, label: i18n.t( 'basic.no') },
			]
		}
	];
	
	// Only show when visible for employees
	if( data.visible_for_employees === settingsOptions.YES ) {
		
		// Show phonenumber
		if( HelperSetting.isYes( settingsConstants.COWORKER_ENABLE_SCREEN ) ) {
			const showFavouriteOptions = [
				{ value: privacyOptions.NO, label: i18n.t( 'form.fields.show_phonenumber.values.no') },
				{ value: privacyOptions.TEAM, label: i18n.t( 'form.fields.show_phonenumber.values.team') },
			];
			
			if( !HelperSetting.isYes( settingsConstants.COWORKER_FAVOURITE_ONLY_FROM_TEAM ) ) {
				showFavouriteOptions.push( { key: privacyOptions.EVERYBODY, value: i18n.t( 'form.fields.show_phonenumber.values.company') } );
			}
			
			formFields.push({
				name: 'show_favourite',
				label: i18n.t('form.fields.show_favourite.title'),
				hint: i18n.t('form.fields.show_favourite.description'),
				type: FormFieldsConstants.SELECT,
				options: showFavouriteOptions
			});
		}
		
		// show calendar
		if( HelperSetting.isYes( settingsConstants.COWORKER_ENABLE_SCREEN ) ) {
			const showCalendarOptions = [
				{ value: privacyOptions.NO, label: i18n.t( 'form.fields.show_calendar.values.no') },
				{ value: privacyOptions.TEAM, label: i18n.t( 'form.fields.show_calendar.values.team') }
			];
			
			if( !HelperSetting.isYes( settingsConstants.COWORKER_CALENDER_ONLY_FROM_TEAM ) ) {
				showCalendarOptions.push( { value: privacyOptions.EVERYBODY, label: i18n.t( 'form.fields.show_calendar.values.company') } );
			}
			
			formFields.push({
				name: 'show_calendar',
				label: i18n.t('form.fields.show_calendar.title'),
				hint: i18n.t('form.fields.show_calendar.description'),
				type: FormFieldsConstants.SELECT,
				options: showCalendarOptions
			});
		}
		
		// show phonenumber
		if( HelperSetting.isYes( settingsConstants.COWORKER_ENABLE_SCREEN ) && HelperSetting.isYes( settingsConstants.COWORKER_SHOW_PHONENUMBER ) ) {
			const showPhonenumberOptions = [
				{ value: privacyOptions.NO, label: i18n.t( 'form.fields.show_phonenumber.values.no') },
				{ value: privacyOptions.TEAM, label: i18n.t( 'form.fields.show_phonenumber.values.team') },
			];
			
			if( !HelperSetting.isYes( settingsConstants.COWORKER_PHONENUMBER_ONLY_FROM_TEAM ) ) {
				showPhonenumberOptions.push( { value: privacyOptions.EVERYBODY, label: i18n.t( 'form.fields.show_phonenumber.values.company') } );
			}
			
			formFields.push({
				name: 'show_phonenumber',
				label: i18n.t('form.fields.show_phonenumber.title'),
				type: FormFieldsConstants.SELECT,
				options: showPhonenumberOptions
			});
		}
	}
	
	if( _.size( formFields ) > 0 ) {
		return (
			<ThemedBlock
				mediumPadding
				shadow>
				
				<Form
					key={ HelperString.hash( 'privacy-form', unique ) }
					values={ data }
					fields={ formFields }
					onChange={ onChange.bind( this ) }
					hideSubmit={ true }
				/>
			</ThemedBlock>
		)
	}
	
	return (
		<NoResultsView>{ i18n.t('page.profile.settings.no_settings') }</NoResultsView>
	)
}

export default PrivacyTab;
